import { useTranslation } from "react-i18next";
import { Badge, IconButton, SvgIcon, Tooltip, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { usePopover } from "@hooks/shared/use-popover";
import useNotificationsStore from "@stores/shared/useNotificationsStore";
import { NotificationsPopover } from "@components/shared/elements/notifications-popover";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell } from "@fortawesome/pro-light-svg-icons";

export const NotificationsButton = () => {
  const popover = usePopover();
  const { t } = useTranslation();
  const theme = useTheme();

  const { notifications } = useNotificationsStore();

  return (
    <>
      {notifications && (
        <>
          <Tooltip title={t("common.notifications")}>
            <IconButton
              data-testid="notifications-button"
              ref={popover.anchorRef}
              onClick={popover.handleOpen}
              sx={{
                backgroundColor: popover.open ? alpha(theme.palette.common.white, 0.1) : "transparent",
                color: popover.open ? theme.palette.primary.contrastText : theme.palette.common.white,
                fontWeight: popover.open ? 700 : undefined,
              }}
            >
              <Badge
                className="no-print"
                sx={{
                  "& .MuiBadge-badge": {
                    backgroundColor: theme.palette.brand,
                    color: "white",
                  },
                }}
                badgeContent={notifications.filter((n) => !n.seen).length}
              >
                <SvgIcon>
                  <FontAwesomeIcon icon={faBell} color="white" />
                </SvgIcon>
              </Badge>
            </IconButton>
          </Tooltip>

          <NotificationsPopover
            anchorEl={popover.anchorRef.current}
            onClose={popover.handleClose}
            open={popover.open}
          />
        </>
      )}
    </>
  );
};
